import { css } from 'styled-components';
import standardCss from './schemes/standard.css';
import blueCss from './schemes/blue.css';
import greenCss from './schemes/green.css';
import orangeCss from './schemes/orange.css';
import pinkCss from './schemes/pink.css';
import purpleCss from './schemes/purple.css';
import redCss from './schemes/red.css';
import yellowCss from './schemes/yellow.css';
import errorCss from './schemes/error.css';
import infoCss from './schemes/info.css';
import successCss from './schemes/success.css';
import warningCss from './schemes/warning.css';
import vendorHubspotCss from './schemes/vendor-hubspot.css';
import vendorMarketoCss from './schemes/vendor-marketo.css';
import vendorPardotCss from './schemes/vendor-pardot.css';
import navCss from './schemes/nav.css';

export const standardColorScheme = css`
  ${standardCss}
`;

export const blueColorScheme = css`
  ${blueCss}
`;

export const greenColorScheme = css`
  ${greenCss}
`;

export const orangeColorScheme = css`
  ${orangeCss}
`;

export const pinkColorScheme = css`
  ${pinkCss}
`;

export const purpleColorScheme = css`
  ${purpleCss}
`;

export const redColorScheme = css`
  ${redCss}
`;

export const yellowColorScheme = css`
  ${yellowCss}
`;

export const errorColorScheme = css`
  ${errorCss}
`;

export const infoColorScheme = css`
  ${infoCss}
`;

export const successColorScheme = css`
  ${successCss}
`;

export const warningColorScheme = css`
  ${warningCss}
`;

export const vendorHubspotColorScheme = css`
  ${vendorHubspotCss}
`;

export const vendorMarketoColorScheme = css`
  ${vendorMarketoCss}
`;

export const vendorPardotColorScheme = css`
  ${vendorPardotCss}
`;

export const navColorScheme = css`
  ${navCss}
`;
